var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        { staticClass: "layout-menu-loading" },
        [
          _c("c-spinner", {
            staticClass: "logo loading",
            attrs: { size: "md" }
          })
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "layout-menu" },
        [
          _c("div", { staticClass: "header" }, [
            _c(
              "div",
              {
                staticClass: "profile-picture",
                attrs: { "data-cy": "profile-menu-picture" },
                on: {
                  click: function($event) {
                    return _vm.editProfile()
                  }
                }
              },
              [
                _c("c-avatar", {
                  attrs: { size: "lg", image: _vm.user.avatar }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "user-info" }, [
              _c(
                "h3",
                {
                  staticClass: "name",
                  on: {
                    click: function($event) {
                      return _vm.editProfile()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.user.name || _vm.user.document) +
                      "\n      "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.$can("awards") ||
          _vm.$can("cashback_tab") ||
          _vm.$can("engagement")
            ? _c("wallet-buttons", {
                staticClass: "wallet-balances",
                on: {
                  close: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "items" },
            [
              _vm._l(_vm.items, function(item, index) {
                return _c(
                  item.external ? "a" : "router-link",
                  {
                    key: index,
                    tag: "div",
                    staticClass: "item -with-border",
                    attrs: {
                      "data-cy": "profile-menu-items",
                      href: item.external ? item.path : null,
                      to: item.external ? null : item.path,
                      target: item.external ? "_blank" : null
                    },
                    on: {
                      click: function($event) {
                        _vm.handleAnalytics(item)
                        _vm.$emit("close")
                      },
                      mousedown: function($event) {
                        return _vm.handleAnalytics(item)
                      }
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("k-icon", { attrs: { icon: item.icon, size: "20" } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "name" }, [
                      _vm._v("\n        " + _vm._s(item.name) + "\n      ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("k-icon", {
                          attrs: { icon: "arrow-right", size: "10" }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              _vm._v(" "),
              (_vm.config.has_api_access && _vm.config.logout) ||
              !_vm.config.has_api_access
                ? _c(
                    "div",
                    {
                      staticClass: "item",
                      attrs: { "data-cy": "profile-menu-logout" },
                      on: {
                        click: function($event) {
                          _vm.handleAnalytics("Sair")
                          _vm.$emit("logout")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "icon" },
                        [
                          _c("k-icon", {
                            attrs: { icon: "exit-door-log-out2", size: "15" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "name" }, [
                        _vm._v("\n        Sair\n      ")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aaf6664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aaf6664","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/LayoutMenu.vue
// module id = 2082
// module chunks = 1610